module.exports = "/fonts/NunitoSans-Light.4f4cdfde5b4212a7aae11d387732aafb.ttf";